/* tslint:disable */
/* tslint:disable */
/**
 * ClearFlask Admin API
 * ClearFlask API documentation.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/* tslint:disable */
// eslint-disable-next-line no-unused-vars
import { exists } from '../runtime';
/**
 * 
 * @export
 * @interface Intercom
 */
export interface Intercom {
    /**
     * 
     * @type {string}
     * @memberof Intercom
     */
    appId: string;
}

export function IntercomFromJSON(json: any): Intercom {
    return {
        'appId': json['appId'],
    };
}

export function IntercomToJSON(value?: Intercom): any {
    if (value === undefined) {
        return undefined;
    }
    return {
        'appId': value.appId,
    };
}


